export const state = () => ({
  list: [],
})

export const mutations = {
  UPDATE_ROOT: (state, payload) => Object.assign(state, payload),
}

export const actions = {
  async fetch({ commit }) {
    try {
      const { data } = await this.$axios.get('/v2/app/coaching/pdvs')
      commit('UPDATE_ROOT', { list: data })
    } catch (e) {
      $nuxt.$rollbar.error(e)
    }
  },
}
